import styled from "styled-components";
import { mobileScreen } from "../../utils/breakpoints";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 3% 0 5%;
`;

const ExternalLink = styled.a`
  color: rgba(202, 72, 94, 0.95);
  text-decoration: none;
  position: relative;
  z-index: 0;
  border-radius: 12px;
  padding: 0;
  transition: color 150ms ease, text-shadow 200ms ease;

  &:hover,
  &:focus-visible {
    color: rgba(224, 94, 116, 0.98);
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.45);
  }

  &::after {
    content: "";
    position: absolute;
    inset: -2px -4px;
    border-radius: 999px;
    background: rgba(224, 94, 116, 0.18);
    border: 1px solid rgba(224, 94, 116, 0.38);
    box-shadow: 0 8px 18px rgba(31, 41, 55, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    opacity: 0;
    transform: scale(0.96);
    transition: opacity 200ms ease, transform 220ms ease;
    pointer-events: none;
  }

  &:hover::after,
  &:focus-visible::after {
    opacity: 1;
    transform: scale(1);
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      transition: none;
    }
  }
`;

const AboutMeContainer = styled.div`
  flex-direction: column;
  margin-top: 2%;
  display: flex;
  justify-content: center;
  width: 42%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 26px;
  padding: 28px 26px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    145deg,
    rgba(255, 255, 255, 0.48),
    rgba(255, 255, 255, 0.16)
  );
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 24px 45px rgba(31, 41, 55, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.7),
    inset 0 -10px 25px rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(26px) saturate(160%);
  -webkit-backdrop-filter: blur(26px) saturate(160%);
  transition: transform 260ms ease, box-shadow 260ms ease,
    background 320ms ease;

  &::before {
    content: "";
    position: absolute;
    top: -35%;
    left: -10%;
    width: 70%;
    height: 70%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0)
    );
    opacity: 0.6;
    pointer-events: none;
    transition: transform 400ms ease, opacity 400ms ease;
  }

  &:hover,
  &:focus-within {
    transform: translateY(-2px);
    background: linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.56),
      rgba(255, 255, 255, 0.18)
    );
    box-shadow: 0 30px 60px rgba(31, 41, 55, 0.22),
      inset 0 1px 0 rgba(255, 255, 255, 0.75),
      inset 0 -14px 28px rgba(255, 255, 255, 0.25);
  }

  &:hover::before,
  &:focus-within::before {
    transform: translate3d(10%, -8%, 0);
    opacity: 0.75;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &::before {
      transition: none;
    }

    &:hover,
    &:focus-within {
      transform: none;
    }
  }

  ${mobileScreen} {
    margin-top: 8%;
    width: 88%;
    padding: 24px 20px;
  }
`;

const AboutMeText = styled.p`
  font-size: 17px;
  line-height: 1.65;
  color: #1f2933;
  width: 100%;
  margin-bottom: 0;
`;

const Dinkus = styled.div`
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
  color: rgba(63, 74, 87, 0.7);
  letter-spacing: 3px;
`;

export {
  Container,
  ExternalLink,
  AboutMeContainer,
  AboutMeText,
  Dinkus,
};
